export class NavHeaderConfig {
    // Image url
    public imageUrl: string;
    // Image url
    public defaultImageUrl: string;
    // Title
    public title: string;
    // Subtitle
    public subtitle: string;
    // image styles
    public imageCss: string;
    // Handle header click event
    click: () => void;
    // Event name
    event: string
};